<app-banner [heading]="'OUR INFRA - GYMNASIUM'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
    <!-- ======= About Section ======= -->
   <section id="about" class="about">

     <div class="container">
       <div class="row">

         <div class="col-lg-4 col-md-6">
           <div class="about-img">
             <img src="assets/img/infra/gym/gym1.jpg" alt="best school in kurukshetra">
           </div>
           <div class="about-img">
             <img src="assets/img/infra/gym/gym2.jpg" alt="best school in kurukshetra">
           </div>
         </div>

         <div class="col-lg-8 col-md-6">
           <div class="about-content">
             <h6 class=""> Gymanisum</h6>
             
             <p>It is great news to know that our school, TAGORE GLOBAL SCHOOL KURUKSHETRA, is having its own multiplex gym 
             with ultra modern facilities and equipments. The main objective of the gym is to help the students
             develop more strength and stamina in terms of their health and other activities.The formation of 
             the gym will enhance the overall development of the students as they will be exposed to many types
             of exercises to improve their fitness and endurance power. The basic aim of the gym is to give the
             students a change from their regular time table of studies and classes. It helps them to acquire more
             sports skills and makes them shine brighter in the field. The gym is equipped with Treadmills, 
             Weight bars, Cross Trainers and Cycling Machines etc.
             that will help the students to burn the extra fat and also energize them from their lethargic
             approach to the surroundings. Gym is another way of making the child stronger in terms of his/her 
             health and cautious about building a slimmer body. A proper session on the importance of exercises 
             will be given along with an encouragement towards staying fit and trim. Building a gym in school 
             will help children to take active participation in physical activities which they neglect otherwise.
             Every equipment in the gym has its own importance. A Treadmill is one of the cardiovascular machines
             that help in cutting down of high level calories and develop the body muscles. The easy access to Dumbbell
             s makes students tone up their loose muscles and built physique. Skipping and crunches will help students to
             engage in more sports and other co-curriculum activities like Athletics.We all know a healthy body is more 
             active and largely helps in better concentration towards everything. A gym will help not just to keep fit
             but also the students will be active and attentive in their classes. Hence, the gym in school is an ideal 
             idea for us to encourage the students to participate in not just sports on special occasions but also adapt
             them in their regular lifestyle.
             </p>
             
           </div>
         </div>
         <div class="col-lg-4 col-md-6">
           <div class="about-img">
             <img src="assets/img/infra/gym/gym3.jpg" alt="best school in kurukshetra">
           </div>
         </div>
         <div class="col-lg-4 col-md-6">
           <div class="about-img">
             <img src="assets/img/infra/gym/gym4.jpg" alt="best school in kurukshetra">
           </div>
         </div>
         <div class="col-lg-4 col-md-6">
           <div class="about-img">
             <img src="assets/img/infra/gym/gym5.jpg" alt="best school in kurukshetra">
           </div>
         </div>
         
       </div>
     </div>
   </section><!-- End About Section -->
    
 </main>